"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAutoAcceptedTimeWindow = exports.canAskEstimatedPickupTime = exports.getEstimatedPickupDropoffTimeOptions = exports.isBrCounterOfferPending = exports.isCounterOfferPending = exports.pendingBookingRequestCounterOfferStatuses = exports.isBrPending = exports.isPending = exports.pendingBookingRequestStatuses = exports.isBrRefused = exports.isRefused = exports.refusedBookingRequestStatuses = exports.isBrAccepted = exports.isAccepted = exports.acceptedBookingRequestStatuses = void 0;
var moment_1 = __importDefault(require("@ambler/moment"));
var mission_1 = require("./core/mission");
var rules_1 = require("./transport-reasons/rules");
var utils_1 = require("./utils");
// If you're looking for an explanation on how this works, look for `TypeScript trick` in `invoice.ts`
// --- ACCEPTED ---
exports.acceptedBookingRequestStatuses = [
    'ACCEPTED',
    'TC_ACCEPTED',
    'HPTL_ACCEPTED',
    'TPTR_ACCEPTED',
    'AUTO_ACCEPTED',
];
var isAccepted = function (status) {
    var acceptedBookingRequestStatuses_ = exports.acceptedBookingRequestStatuses;
    return acceptedBookingRequestStatuses_.includes(status);
};
exports.isAccepted = isAccepted;
var isBrAccepted = function (br) { return (0, exports.isAccepted)(br.status); };
exports.isBrAccepted = isBrAccepted;
// --- REFUSED ---
exports.refusedBookingRequestStatuses = [
    'DECLINED',
    'TC_REFUSED',
    'HPTL_REFUSED',
    'TPTR_REFUSED',
    'HOLIDAY_REFUSED',
    'BLACKLISTED',
];
var isRefused = function (status) {
    var refusedBookingRequestStatuses_ = exports.refusedBookingRequestStatuses;
    return refusedBookingRequestStatuses_.includes(status);
};
exports.isRefused = isRefused;
var isBrRefused = function (br) { return (0, exports.isRefused)(br.status); };
exports.isBrRefused = isBrRefused;
// --- PENDING ---
exports.pendingBookingRequestStatuses = ['PENDING', 'PROTECTED'];
var isPending = function (status) {
    var pendingBookingRequestStatuses_ = exports.pendingBookingRequestStatuses;
    return pendingBookingRequestStatuses_.includes(status);
};
exports.isPending = isPending;
var isBrPending = function (br) { return (0, exports.isPending)(br === null || br === void 0 ? void 0 : br.status); };
exports.isBrPending = isBrPending;
exports.pendingBookingRequestCounterOfferStatuses = ['COUNTER_OFFER_PENDING'];
var isCounterOfferPending = function (status) {
    var pendingBookingRequestStatuses_ = exports.pendingBookingRequestCounterOfferStatuses;
    return pendingBookingRequestStatuses_.includes(status);
};
exports.isCounterOfferPending = isCounterOfferPending;
var isBrCounterOfferPending = function (br) { return (0, exports.isCounterOfferPending)(br === null || br === void 0 ? void 0 : br.status); };
exports.isBrCounterOfferPending = isBrCounterOfferPending;
// --- ESTIMATED PICKUP TIME ---
var canUseFlexibleDeadline = function (departureTime) {
    var minutesToDeadline = (0, moment_1.default)(departureTime).diff((0, moment_1.default)(), 'minutes', true);
    // We only use the flexible deadline if we have at least 20mins,
    // Because we want to have at least 5 min between the MT Request Visualization Time and the EPT option he can select.
    return minutesToDeadline >= 20;
};
var getEstimatedPickupDropoffTimeOptions = function (bookingRequest) {
    var _a;
    var mission = bookingRequest.mission;
    if (mission.type !== 'SOLO_SIMPLE') {
        return [];
    }
    var passengers = mission.trips[0].passengers;
    var _b = passengers[0], departureTime = _b.departureTime, timeReference = _b.timeReference, direction = _b.direction, arrivalTime = _b.arrivalTime;
    if (!departureTime || !timeReference || !direction) {
        return [];
    }
    var isAsap = (0, mission_1.isAsapMission)(mission);
    // #1: ASAP missions with flexible deadline
    if (isAsap && canUseFlexibleDeadline(departureTime)) {
        return (0, rules_1.getMtEstimatedPickupTimeOptions)(departureTime).map(function (time) { return ({ pickupTime: time }); });
    }
    // #2: Non-ASAP missions with preferred MT
    if (isAsap) {
        return [];
    }
    var _c = passengers[0], payer = _c.payer, mfu = _c.mfu, preferredMt = _c.preferredMt, transportReason = _c.transportReason;
    if (!payer || !mfu || !preferredMt || !transportReason) {
        return [];
    }
    if (preferredMt.id !== bookingRequest.mt.id) {
        return [];
    }
    if (!(0, rules_1.hasAlternativePickupTime)(transportReason)) {
        return [];
    }
    var preferredMtRule = (_a = mfu.customization) === null || _a === void 0 ? void 0 : _a.missionPreferredMtRules.find(function (rule_) {
        return rule_.payers.map(function (_a) {
            var payer = _a.payer;
            return payer;
        }).includes(payer);
    });
    if (!preferredMtRule) {
        return [];
    }
    if (timeReference === 'ARRIVAL' && preferredMtRule.allowedArrivalMargin !== 'NONE') {
        switch (preferredMtRule.allowedArrivalMargin) {
            case 'MINUS_45':
                return [
                    {
                        pickupTime: (0, moment_1.default)(departureTime).subtract(45, 'minutes'),
                        dropoffTime: (0, moment_1.default)(arrivalTime).subtract(45, 'minutes'),
                    },
                    {
                        pickupTime: (0, moment_1.default)(departureTime).subtract(30, 'minutes'),
                        dropoffTime: (0, moment_1.default)(arrivalTime).subtract(30, 'minutes'),
                    },
                    {
                        pickupTime: (0, moment_1.default)(departureTime).subtract(15, 'minutes'),
                        dropoffTime: (0, moment_1.default)(arrivalTime).subtract(15, 'minutes'),
                    },
                    { pickupTime: (0, moment_1.default)(departureTime), dropoffTime: (0, moment_1.default)(arrivalTime) },
                ];
            case 'MINUS_60':
                return [
                    {
                        pickupTime: (0, moment_1.default)(departureTime).subtract(60, 'minutes'),
                        dropoffTime: (0, moment_1.default)(arrivalTime).subtract(60, 'minutes'),
                    },
                    {
                        pickupTime: (0, moment_1.default)(departureTime).subtract(30, 'minutes'),
                        dropoffTime: (0, moment_1.default)(arrivalTime).subtract(30, 'minutes'),
                    },
                    { pickupTime: (0, moment_1.default)(departureTime), dropoffTime: (0, moment_1.default)(arrivalTime) },
                ];
            case 'MINUS_90':
                return [
                    {
                        pickupTime: (0, moment_1.default)(departureTime).subtract(90, 'minutes'),
                        dropoffTime: (0, moment_1.default)(arrivalTime).subtract(90, 'minutes'),
                    },
                    {
                        pickupTime: (0, moment_1.default)(departureTime).subtract(60, 'minutes'),
                        dropoffTime: (0, moment_1.default)(arrivalTime).subtract(60, 'minutes'),
                    },
                    {
                        pickupTime: (0, moment_1.default)(departureTime).subtract(30, 'minutes'),
                        dropoffTime: (0, moment_1.default)(arrivalTime).subtract(30, 'minutes'),
                    },
                    { pickupTime: (0, moment_1.default)(departureTime), dropoffTime: (0, moment_1.default)(arrivalTime) },
                ];
        }
        (0, utils_1.assertUnreachable)(preferredMtRule.allowedArrivalMargin);
    }
    if (timeReference === 'DEPARTURE' && preferredMtRule.allowedDepartureMargin !== 'NONE') {
        switch (preferredMtRule.allowedDepartureMargin) {
            case 'PLUS_45':
                return [
                    { pickupTime: (0, moment_1.default)(departureTime) },
                    { pickupTime: (0, moment_1.default)(departureTime).add(15, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(30, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(45, 'minutes') },
                ];
            case 'PLUS_60':
                return [
                    { pickupTime: (0, moment_1.default)(departureTime) },
                    { pickupTime: (0, moment_1.default)(departureTime).add(30, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(60, 'minutes') },
                ];
            case 'PLUS_90':
                return [
                    { pickupTime: (0, moment_1.default)(departureTime) },
                    { pickupTime: (0, moment_1.default)(departureTime).add(30, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(60, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(90, 'minutes') },
                ];
            case 'PLUS_OR_MINUS_45':
                return [
                    { pickupTime: (0, moment_1.default)(departureTime).subtract(45, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).subtract(30, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).subtract(15, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime) },
                    { pickupTime: (0, moment_1.default)(departureTime).add(15, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(30, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(45, 'minutes') },
                ];
            case 'PLUS_OR_MINUS_60':
                return [
                    { pickupTime: (0, moment_1.default)(departureTime).subtract(60, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).subtract(30, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime) },
                    { pickupTime: (0, moment_1.default)(departureTime).add(30, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(60, 'minutes') },
                ];
            case 'PLUS_OR_MINUS_90':
                return [
                    { pickupTime: (0, moment_1.default)(departureTime).subtract(90, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).subtract(60, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).subtract(30, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime) },
                    { pickupTime: (0, moment_1.default)(departureTime).add(30, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(60, 'minutes') },
                    { pickupTime: (0, moment_1.default)(departureTime).add(90, 'minutes') },
                ];
        }
        (0, utils_1.assertUnreachable)(preferredMtRule.allowedDepartureMargin);
    }
    return [];
};
exports.getEstimatedPickupDropoffTimeOptions = getEstimatedPickupDropoffTimeOptions;
var canAskEstimatedPickupTime = function (bookingRequest) {
    return (0, exports.getEstimatedPickupDropoffTimeOptions)(bookingRequest).length > 0;
};
exports.canAskEstimatedPickupTime = canAskEstimatedPickupTime;
var getAutoAcceptedTimeWindow = function (time, interval) {
    return [(0, moment_1.default)(time).add(interval[0], 'minutes'), (0, moment_1.default)(time).add(interval[1], 'minutes')];
};
exports.getAutoAcceptedTimeWindow = getAutoAcceptedTimeWindow;
//# sourceMappingURL=booking-request.js.map